import React from 'react';
import Section from '@atoms/Section/Section';
import { SwiperSlide, Swiper } from 'swiper/react';
import Title from '@atoms/Title/Title';
import Icon from '@atoms/Icon/Icon';
import './UspBanners.scss';
import GenericIcon from './GenericIcon';
import 'swiper/css/bundle';
import { Autoplay } from 'swiper/modules';

const UspBanners = ({ list }) => {
    return (
        <Section container="large" className="UspBannersWrapper">
            <div className="UspBanners">
                <Swiper
                    loop
                    direction="horizontal"
                    slidesPerView="auto"
                    freeMode
                    autoplay={{
                        delay: 0,
                        // pauseOnMouseEnter: true,
                        disableOnInteraction: false,
                        waitForTransition: true,
                        stopOnLastSlide: false,
                    }}
                    speed={5000}
                    modules={[Autoplay]}
                    allowTouchMove={false}
                    breakpoints={{
                        560: {
                            speed: 10000,
                        },
                    }}
                >
                    {list.map((item: any, index: number) => {
                        return (
                            <SwiperSlide key={`UspBanners--item${index}`}>
                                <Icon
                                    icon={<GenericIcon icon={item.icon} />}
                                    theme="white"
                                    size="s"
                                />
                                <Title noMargin theme="white" size="m">
                                    {item.button.label}
                                </Title>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </Section>
    );
};

export default UspBanners;
